<template>
    <div id="alliances">
        <!--=====================================-->
        <!--=        Brand Area Start       	=-->
        <!--=====================================-->
        <section class="section section-padding bg-color-dark sunflower-line-background-alliances">
            <div class="container">
                <div class="section-heading heading-light-left">
                    <span class="subtitle primary">Alianzas.</span>
                    <h2 class="title font-weight-100">Grandes <span class="bold primary">aliados</span> <br> que te acompañan.</h2>
                </div>
                <div class="row align-items-center">
                    <div class="col-lg-3 col-6 mb--20">
                        <div class="brand-logo">
                            <img :src="`${logo_base}conservation-international.png`" alt="Brand">
                        </div>
                    </div>
                    <div class="col-lg-3 col-6 mb--20">
                        <div class="brand-logo">
                            <img :src="`${logo_base}giz.png`" alt="Brand">
                        </div>
                    </div>
                    <div class="col-lg-3 col-6 mb--20">
                        <div class="brand-logo femsa">
                            <img :src="`${logo_base}femsa.png`" alt="Brand">
                        </div>
                    </div>
                    <div class="col-lg-3 col-6 mb--20">
                        <div class="brand-logo">
                            <img :src="`${logo_base}svx.png`" alt="Brand">
                        </div>
                    </div>

                </div>
            </div>
        </section>
    </div>
</template>

<script>

export default {
    name: "Alliances",
    components: {
    },
    data() {
        return {
            logo_base: "https://cdn.redgirasol.com/nuevo_portal/logos/logo-"
        }
    }
}

</script>

<style scoped>

.brand-logo img {
    width: 90%;
}

.brand-logo.femsa {
    width: 65% !important;
    text-align: center;
    margin-left: 15%;
    margin-right: 15%;
}

</style>